/**
 * SEO Page Examples - Template for each major page
 * Copy and adapt these examples to your actual pages
 */

// ============================================
// PAGE 1: DASHBOARD/HOME PAGE (Bien)
// ============================================
export const DASHBOARD_SEO = {
  title: 'Tableau de Bord - Espace Client OPGI Boumerdès',
  description: 'Accédez à votre tableau de bord personnel. Consultez vos informations de locataire, votre solde, paiements récents et gestion de votre dossier OPGI de manière sécurisée.',
  keywords: 'tableau de bord OPGI, espace locataire, gestion dossier OPGI, informations locataire',
  canonical: 'https://client.opgi-boumerdes.dz/',
  breadcrumbs: [
    { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Tableau de Bord', url: 'https://client.opgi-boumerdes.dz/' }
  ],
  ogImage: 'https://client.opgi-boumerdes.dz/images/dashboard-og.png'
};

/**
 * Usage in Dashboard.js:
 * 
 * import { useSEO } from '../utils/SEOHelper';
 * 
 * export default function Dashboard() {
 *   useSEO(DASHBOARD_SEO);
 *   return (
 *     <main>
 *       <h1>Tableau de Bord</h1>
 *       // Dashboard content
 *     </main>
 *   );
 * }
 */

// ============================================
// PAGE 2: PAYMENT PAGE (Payement)
// ============================================
export const PAYMENT_SEO = {
  title: 'Effectuer un Paiement - OPGI Boumerdès Paiement en Ligne',
  description: 'Effectuez votre paiement de loyer en ligne de manière sécurisée. Paiement instantané, confirmation immédiate et reçu numérique. Plateforme de paiement fiable et certifiée.',
  keywords: 'paiement loyer OPGI, paiement en ligne, e-payment sécurisé, payer OPGI, paiement électronique',
  canonical: 'https://client.opgi-boumerdes.dz/Payement',
  breadcrumbs: [
    { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Tableau de Bord', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Paiement', url: 'https://client.opgi-boumerdes.dz/Payement' }
  ],
  ogImage: 'https://client.opgi-boumerdes.dz/images/payment-og.png'
};

/**
 * Usage in PaymentPage.js:
 * 
 * import { useSEO } from '../utils/SEOHelper';
 * 
 * export default function PaymentPage() {
 *   useSEO(PAYMENT_SEO);
 *   return (
 *     <main>
 *       <h1>Effectuer un Paiement</h1>
 *       // Payment form
 *     </main>
 *   );
 * }
 */

// ============================================
// PAGE 3: RECEIPTS/PAYMENT HISTORY
// ============================================
export const RECEIPTS_SEO = {
  title: 'Mes Quittances et Reçus - OPGI Boumerdès',
  description: 'Consultez vos quittances de loyer et historique de paiement. Téléchargez et imprimez vos reçus. Archivage numérique sécurisé de tous vos documents OPGI.',
  keywords: 'quittance de loyer OPGI, reçu de paiement, historique paiement, télécharger quittance, archives paiement',
  canonical: 'https://client.opgi-boumerdes.dz/QuittancesPayees',
  breadcrumbs: [
    { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Tableau de Bord', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Quittances', url: 'https://client.opgi-boumerdes.dz/QuittancesPayees' }
  ],
  ogImage: 'https://client.opgi-boumerdes.dz/images/receipts-og.png'
};

/**
 * Usage in ReceiptsPage.js:
 * 
 * import { useSEO } from '../utils/SEOHelper';
 * 
 * export default function ReceiptsPage() {
 *   useSEO(RECEIPTS_SEO);
 *   return (
 *     <main>
 *       <h1>Mes Quittances</h1>
 *       // Receipts list and filters
 *     </main>
 *   );
 * }
 */

// ============================================
// PAGE 4: USER PROFILE/ACCOUNT
// ============================================
export const PROFILE_SEO = {
  title: 'Mon Profil - Gestion de Compte OPGI',
  description: 'Gérez vos informations personnelles, préférences de communication et paramètres de sécurité. Mettez à jour votre profil locataire OPGI en toute sécurité.',
  keywords: 'mon profil OPGI, gestion compte, informations personnelles, paramètres sécurité, préférences notification',
  canonical: 'https://client.opgi-boumerdes.dz/profile',
  breadcrumbs: [
    { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Tableau de Bord', url: 'https://client.opgi-boumerdes.dz/dashboard' },
    { name: 'Mon Profil', url: 'https://client.opgi-boumerdes.dz/profile' }
  ]
};

// ============================================
// PAGE 5: HELP/SUPPORT
// ============================================
export const HELP_SEO = {
  title: 'Aide et Support - OPGI Boumerdès',
  description: 'Centre d\'aide OPGI. FAQ sur les paiements, guide d\'utilisation, contactez le support. Aide et assistance pour votre compte locataire OPGI.',
  keywords: 'aide OPGI, support client, FAQ, contact support, guide utilisation, problème paiement',
  canonical: 'https://client.opgi-boumerdes.dz/doleance',
  breadcrumbs: [
    { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
    { name: 'Aide et Support', url: 'https://client.opgi-boumerdes.dz/doleance' }
  ]
};

/**
 * For FAQ/Help pages, also add FAQPage structured data:
 * 
 * import { useSEO } from '../utils/SEOHelper';
 * import SEOHelper from '../utils/SEOHelper';
 * 
 * export default function HelpPage() {
 *   useSEO(HELP_SEO);
 *   
 *   const faqSchema = {
 *     '@context': 'https://schema.org',
 *     '@type': 'FAQPage',
 *     mainEntity: [
 *       {
 *         '@type': 'Question',
 *         name: 'Comment effectuer un paiement?',
 *         acceptedAnswer: {
 *           '@type': 'Answer',
 *           text: 'Pour payer votre loyer, connectez-vous et cliquez sur Paiement...'
 *         }
 *       },
 *       // Add more FAQ items
 *     ]
 *   };
 *   
 *   React.useEffect(() => {
 *     SEOHelper.updateArticleSchema(faqSchema);
 *   }, []);
 *   
 *   return (
 *     <main>
 *       <h1>Aide et Support</h1>
 *       // Help content with FAQ items
 *     </main>
 *   );
 * }
 */

// ============================================
// PAGE 6: LOGIN PAGE (No indexing needed)
// ============================================
export const LOGIN_SEO = {
  title: 'Connexion - Espace Client OPGI',
  description: 'Connectez-vous à votre compte OPGI pour accéder à votre espace personnel de paiement et gestion de dossier.',
  canonical: 'https://client.opgi-boumerdes.dz/Login'
};

/**
 * For login page, you might want to noindex:
 * Add to index.html for login route OR dynamically:
 * 
 * const meta = document.createElement('meta');
 * meta.name = 'robots';
 * meta.content = 'noindex, follow';
 * document.head.appendChild(meta);
 */

// ============================================
// PROPERTY PAGE TEMPLATE (For dynamic pages)
// ============================================
export function getPropertySEO(propertyData) {
  return {
    title: `Propriété ${propertyData.address} - OPGI Boumerdès`,
    description: `Information sur la propriété ${propertyData.address}. Immeuble OPGI à Boumerdès, ${propertyData.units} unités, construit en ${propertyData.year}.`,
    keywords: `OPGI ${propertyData.address}, immeuble OPGI, propriété, logement locatif, Boumerdès`,
    canonical: `https://client.opgi-boumerdes.dz/property/${propertyData.id}`,
    breadcrumbs: [
      { name: 'Accueil', url: 'https://client.opgi-boumerdes.dz/' },
      { name: 'Propriétés', url: 'https://client.opgi-boumerdes.dz/properties' },
      { name: propertyData.address, url: `https://client.opgi-boumerdes.dz/property/${propertyData.id}` }
    ]
  };
}

/**
 * Usage in PropertyPage.js:
 * 
 * export default function PropertyPage({ propertyId }) {
 *   const [property, setProperty] = useState(null);
 *   
 *   useEffect(() => {
 *     // Fetch property data
 *     fetch(`/api/property/${propertyId}`).then(r => r.json()).then(setProperty);
 *   }, [propertyId]);
 *   
 *   useEffect(() => {
 *     if (property) {
 *       useSEO(getPropertySEO(property));
 *     }
 *   }, [property]);
 *   
 *   return <div>{property && <h1>{property.address}</h1>}</div>;
 * }
 */

// ============================================
// EXPORT ALL SEO CONFIGURATIONS
// ============================================
export const SEO_PAGES = {
  DASHBOARD: DASHBOARD_SEO,
  PAYMENT: PAYMENT_SEO,
  RECEIPTS: RECEIPTS_SEO,
  PROFILE: PROFILE_SEO,
  HELP: HELP_SEO,
  LOGIN: LOGIN_SEO,
};

export default SEO_PAGES;

/**
 * QUICK IMPLEMENTATION GUIDE
 * 
 * 1. In each page component, import the SEO config:
 *    import { DASHBOARD_SEO } from '../config/seoPages';
 * 
 * 2. Use the useSEO hook:
 *    useSEO(DASHBOARD_SEO);
 * 
 * 3. Test with Google Rich Results Test:
 *    https://search.google.com/test/rich-results
 * 
 * 4. Monitor in Google Search Console:
 *    https://search.google.com/search-console
 */
